<section class="p-4 container-fluid">
  <div class="row">
    <div class="col-12 col-lg-4 mb-4 mb-lg-0">
      <h3 class="title mb-4">Añadir propiedad</h3>
      <p-card>
        <h5 class="mb-4 description-text">
          Para añadir una propiedad necesitarás los datos de tu liquidación, puedes ver los ejemplos
          en la parte derecha de la pantalla.
        </h5>

        <form [formGroup]="form" class="form-container">
          <p-floatlabel class="my-3 d-block" variant="in">
            <p-iconfield>
              <p-inputicon class="pi pi-circle-fill fillCode" />
              <input
                pInputText
                type="text"
                id="liquidationCode"
                class="w-100"
                formControlName="liquidationCode"
              />
            </p-iconfield>
            <label for="liquidationCode">Código de liquidación</label>
          </p-floatlabel>

          <p-floatlabel class="my-3 d-block" variant="in">
            <p-iconfield>
              <p-inputicon class="pi pi-circle-fill fillAmount" />
              <input
                pInputText
                type="text"
                id="liquidationAmount"
                class="w-100"
                formControlName="liquidationAmount"
              />
            </p-iconfield>
            <label for="liquidationAmount">Importe de la liquidación</label>
          </p-floatlabel>

          @if (msgError) {
            <p-message styleClass="mb-3 w-100" severity="error">{{ msgError }}</p-message>
          }

          <p-button
            type="submit"
            label="Añadir"
            (onClick)="submit()"
            class="w-100"
            [fluid]="true"
            [disabled]="form.invalid"
          />
          <div class="d-flex justify-content-center mt-3">
            <p-button type="button" link label="Volver" (onClick)="goBack()" class="mx-auto" />
          </div>
        </form>
      </p-card>
    </div>
    <div class="col-12 col-lg-7 offset-lg-1">
      <h3 class="title mb-4">¿Dónde encuentro los datos?</h3>

      <div class="carousel-wrapper">
        <p-carousel
          [value]="images()"
          [autoplayInterval]="4000"
          circular
          [numScroll]="1"
          [numVisible]="1"
          showIndicators="false"
          class="carousel-container"
        >
          <ng-template pTemplate="item" let-image>
            <div class="carousel-item-wrapper">
              <div class="carousel-image">
                <p-image [src]="image.src" [preview]="true" appendTo="body" />
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</section>
